// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__30iaX","inner":"Form_inner__2P--s","range":"Form_range__3ypFz","name":"Form_name__ZJrCk","actions":"Form_actions__1Rfw9"};